import React, { useState, useEffect, forwardRef, useCallback } from 'react'
import { FormattedMessage } from 'react-intl';
import CreateAccountModal from '../Registration/Registration'
import EditAccountModal from '../Registration/RegistrationModal'

const AccountManagementModal = forwardRef((props, ref) => {
  const {
    setResetAccountModalRef,
    onSuccessProp,
    setSuccess, setError,
    selectedAccount, setSelectedAccount,
    success, error,
    closeModal,
    showRegModal, setShowRegModal,
    registrationRef,
    loadTable, dataMap
  } = props;

  const onSuccess = () => {
    document.getElementById('btn-close').click();
    if(onSuccessProp){
      onSuccessProp();
    }
    if(setSuccess){
      setSuccess(<FormattedMessage id="ADDED_ACCOUNT_SUCCESS" />);
    }
  }

  const closeButton = <button type="button" id="btn-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

  // Props to pass to our modal component
  const modalProps = {
    onSuccess,
    closeButton,
    success, setSuccess,
    error, setError,
    closeModal,
    showRegModal, setShowRegModal,
    loadTable,
    dataMap,
    selectedAccount, setSelectedAccount,
    setResetAccountModalRef,
  }

  return (
    <>
      <div className="modal fade" id="createAccountModal" tabIndex="-1" aria-labelledby="AccountManagementModal" aria-hidden="true"> 
        <CreateAccountModal isModal={true} ref={ref} registrationRef={registrationRef} {...modalProps}/>    
      </div>
      <div className="modal fade" id="editAccountModal" tabIndex="-1" aria-labelledby="AccountManagementModal" aria-hidden="true">
        <EditAccountModal isModal={true} {...modalProps}/>    
      </div>
    </>
  )
})

export default (AccountManagementModal)